import { isValidUrl } from "./isValidUrl";

export const fn = {
  isValidUrl,
};
